/*
 * @Author: dali
 * @Date: 2022-08-29 09:53:21
 * @LastEditors: liuzhezhe
 * @LastEditTime: 2023-05-18 17:47:35
 * @FilePath: \gerlun-react-website\src\const\api.js
 * @Description:
 */
export const API_LIST = {
  // 获取数据
  USER_LOGIN: '/service/auth/user/login',
  // 校验手机号接口
  CHECK_PHONE: '/service/auth/user/checkPhone',
  // 用户注册
  USER_REGISTER: '/service/auth/user/userRegister',
  // 获取手机验证码
  GET_PHONE_CODE: '/service/auth/auth/get',
  // 找回密码
  FIND_PASSWORD: '/service/auth/user/forgetPwd',
  // 修改用户信息
  UPD_USERINFO: '/service/auth/user/upd',
  // 修改用户密码
  UPD_PWD: '/service/auth/user/updPwd',
  // 获取用户信息
  GET_USERINFO: '/service/auth/user/getInfo',
  // 获取组织列表
  GET_ORG_LIST: '/service/auth/user/getUserLv1OrgList',
  // 根据token获取用户信息
  GET_USER_BYTOEN: '/service/auth/user/getUserByUserId',
  // 获取产品
  GET_PRODUCT_LIST: '/service/product/prod/getAllProd',
  // 获取产品详情
  GET_PRODUCT_DETAIL: '/service/product/org-prod/getProdList',
  // 退出登录
  GET_USER_EXIT: '/service/auth/user/exit',
  // 校验指定用户是否有指定产品的购买资格
  CHECK_USER_PURCHASE_QUALIFICATION: '/service/product/org-prod/checkPurchaseQualification',
  // 获取产品信息
  GET_PROD_BYCATCD: '/service/product/prodLvl/getProdLvlByCatCd',
  // 预约试用
  TRIAL_ADD: '/service/product/trial/add',
  // 获取文章列表
  GET_ART_LIST: '/service/regulation/article/getList',
  // 获取文章详情
  GET_ART_DETAIL: '/service/regulation/article/getById',
  // 获取 公众号二维码
  GET_WX_LOGIN_QR_CODE: '/service/wx/login/getQRCode',
  // 微信公众号扫码结果
  GET_WX_Login_SCAN_RES: '/service/auth/wechat/mpLoginScaned',
  // 用户微信绑定手机号
  BIND_USER_WECHAT: '/service/auth/wechat/bind',
  // 文章附件下载
  GET_ART_DOWNLOAD: '/service/regulation/opr/article/downloadAttach',
  // 获取用户根组织
  GET_ROOT_ORGS: '/service/auth/org/getRootOrgList',
  // GET_SERIES_LISR: '/x/polymer/space/seasons_series_list'

  // 区域代码查询-新接口
  GET_AREA_CODE: '/service/masterdata/sy-area-code/getAreaCode'
}
